/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateCompanyListResponseData,
  CreateCompanyListResponseDataFromJSON,
  CreateCompanyListResponseDataFromJSONTyped,
  CreateCompanyListResponseDataToJSON
} from './CreateCompanyListResponseData'

/**
 *
 * @export
 * @interface UpdateCompanyListResponse
 */
export interface UpdateCompanyListResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateCompanyListResponse
   */
  status?: number
  /**
   *
   * @type {CreateCompanyListResponseData}
   * @memberof UpdateCompanyListResponse
   */
  data?: CreateCompanyListResponseData
}

export function UpdateCompanyListResponseFromJSON(json: any): UpdateCompanyListResponse {
  return UpdateCompanyListResponseFromJSONTyped(json, false)
}

export function UpdateCompanyListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateCompanyListResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateCompanyListResponseDataFromJSON(json['data'])
  }
}

export function UpdateCompanyListResponseToJSON(value?: UpdateCompanyListResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateCompanyListResponseDataToJSON(value.data)
  }
}
